import styled, { css } from 'styled-components';
import { Field } from 'formik';

import {
  PRIMARY_BLUE,
  PRIMARY_GREY,
  ERROR_RED,
  BLACK,
  MEDIUM_GREY,
  BORDER_GREY
} from 'constants/colours';

export const StyledFormikField = styled(Field)<{ $error?: boolean; $width?: string }>(
  ({ $error, $width }) => css`
    width: ${$width || '100%'};
    height: 48px;
    border: 1.5px solid ${BORDER_GREY};
    border-radius: 4px;
    padding: 14px 16px;
    border-color: ${$error && `${ERROR_RED} !important`};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:focus,
    &:active {
      border-color: ${BLACK};
    }
    &:focus-visible {
      border-color: ${PRIMARY_BLUE};
      outline: none;
    }
    &:disabled {
      background: none;
      border-color: ${BORDER_GREY};
      color: ${MEDIUM_GREY};
    }
    &:is(textarea) {
      min-height: 64px;
    }
  `
);

export const SubText = styled.p<{ disabled?: boolean }>(
  ({ disabled }) => css`
    margin-top: 8px;
    font-size: 12px;
    line-height: 16px;
    color: ${PRIMARY_GREY};
    opacity: ${disabled && '0.5'};
  `
);

export const RelativeWrapper = styled.div<{ zIndex?: number | null }>`
  position: relative;
  width: 100%;
  z-index: ${({ zIndex }): any => zIndex};
`;

export const CharacterCount = styled.div`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${MEDIUM_GREY};
`;
